(function($){
	$(document).ready(function() {
		// Hamburger button
		$( '.responsive-menu-button' ).on( 'click', function() {
		    $( '.responsive-menu-container' ).toggleClass( 'is-open' );
		    $( '.responsive-menu-button' ).toggleClass( 'is-active' );
				$( 'body' ).toggleClass( 'lock' ); // Disable scroll when mobile menu is open
	  });

		/* Toggle submenu */
		// Give menu item with children an icon
		$( '<span class="menu-dropdown-icon"><i class="fas fa-caret-down"></i></span>' ).appendTo( '.responsive-menu-container .menu-item-has-children' );

		// Show submenu on click dropdown icon
		$( '.responsive-menu-container .menu-item-has-children .menu-dropdown-icon' ).on( 'click tap', function() {
			$( this ).parent().find( '> ul.sub-menu' ).slideToggle( 250, 'swing' );
			$( this ).parent().toggleClass( 'sub-menu-open' );
		});
	});
}(jQuery));
